import { StartBird } from "../start-bird"
import path1 from '../../../../assets/models/paths/path1.json'
import path2 from '../../../../assets/models/paths/path2.json'
import path3 from '../../../../assets/models/paths/path3.json'
import path4 from '../../../../assets/models/paths/path4.json'
import path5 from '../../../../assets/models/paths/path5.json'
import bird1 from "../../../../assets/scenes/bird.glb"
import { useGLTF } from "@react-three/drei"
import { useEffect, useMemo } from "react"
import * as SkeletonUtils from 'three/addons/utils/SkeletonUtils.js';


export const PATHS = [path1, path2, path3, path4, path5]


const StartBirdsWrap = () => {
  const { scene, animations } = useGLTF(bird1);
  const scene2 = useMemo(() => {
    const clone = SkeletonUtils.clone(scene);  // Клонування зі збереженням скелета
    clone.position.set(0, 1, 0);  // Встановлюємо нову позицію для клона
    return clone;
  }, [scene]);
  const scene3 = useMemo(() => {
    const clone = SkeletonUtils.clone(scene);  // Клонування зі збереженням скелета
    clone.position.set(0, 1, 0);  // Встановлюємо нову позицію для клона
    return clone;
  }, [scene]);
  const scene4 = useMemo(() => {
    const clone = SkeletonUtils.clone(scene);  // Клонування зі збереженням скелета
    clone.position.set(0, 1, 0);  // Встановлюємо нову позицію для клона
    return clone;
  }, [scene]);
  const scene5 = useMemo(() => {
    const clone = SkeletonUtils.clone(scene);  // Клонування зі збереженням скелета
    clone.position.set(0, 1, 0);  // Встановлюємо нову позицію для клона
    return clone;
  }, [scene]);
  const scene6 = useMemo(() => {
    const clone = SkeletonUtils.clone(scene);  // Клонування зі збереженням скелета
    clone.position.set(0, 1, 0);  // Встановлюємо нову позицію для клона
    return clone;
  }, [scene]);
  const scene7 = useMemo(() => {
    const clone = SkeletonUtils.clone(scene);  // Клонування зі збереженням скелета
    clone.position.set(0, 1, 0);  // Встановлюємо нову позицію для клона
    return clone;
  }, [scene]);
  const scene8 = useMemo(() => {
    const clone = SkeletonUtils.clone(scene);  // Клонування зі збереженням скелета
    clone.position.set(0, 1, 0);  // Встановлюємо нову позицію для клона
    return clone;
  }, [scene]);
  const scene9 = useMemo(() => {
    const clone = SkeletonUtils.clone(scene);  // Клонування зі збереженням скелета
    clone.position.set(0, 1, 0);  // Встановлюємо нову позицію для клона
    return clone;
  }, [scene]);
  const scene10 = useMemo(() => {
    const clone = SkeletonUtils.clone(scene);  // Клонування зі збереженням скелета
    clone.position.set(0, 1, 0);  // Встановлюємо нову позицію для клона
    return clone;
  }, [scene]);
  const scene11 = useMemo(() => {
    const clone = SkeletonUtils.clone(scene);  // Клонування зі збереженням скелета
    clone.position.set(0, 1, 0);  // Встановлюємо нову позицію для клона
    return clone;
  }, [scene]);
  const scene12 = useMemo(() => {
    const clone = SkeletonUtils.clone(scene);  // Клонування зі збереженням скелета
    clone.position.set(0, 1, 0);  // Встановлюємо нову позицію для клона
    return clone;
  }, [scene]);



  return (
    <>
      <StartBird animations={animations} scene={scene8} start={{y: 3.8, z: 6.8, x: -14.8}} birdColor="orange" />
      <StartBird animations={animations} scene={scene9} start={{y: 3.8, z: 6.6, x: -14.8}} birdColor="orange" />
      <StartBird animations={animations} scene={scene10} start={{y: 3.8, z: 6.4, x: -14.8}} birdColor="orange" />
      <StartBird animations={animations} scene={scene5} start={{y: 3.8, z: 7.2, x: -14.8}} birdColor="orange" />
      <StartBird animations={animations} scene={scene4} start={{y: 3.8, z: 7.4, x: -14.8}} birdColor="green" />
      <StartBird animations={animations} scene={scene3} start={{y: 3.8, z: 7.6, x: -14.8}} birdColor="pink" />
      <StartBird animations={animations} scene={scene2} start={{y: 3.8, z: 7.8, x: -14.8}} birdColor="violet" />
      <StartBird animations={animations} scene={scene} start={{y: 3.8, z: 8, x: -14.8}} birdColor="yellow" />
      <StartBird animations={animations} scene={scene6} start={{y: 3.8, z: 8.2, x: -14.8}} birdColor="orange" />
      <StartBird animations={animations} scene={scene7} start={{y: 3.8, z: 8.4, x: -14.8}} birdColor="green" />
      <StartBird animations={animations} scene={scene12} start={{y: 3.8, z: 8.6, x: -14.8}} birdColor="yellow" />
      <StartBird animations={animations} scene={scene11} start={{y: 3.8, z: 7.0, x: -14.8}} birdColor="orange" />

    </>
  )
}

export {
  StartBirdsWrap
}